import { useNavigate } from 'react-router-dom'

import { Box, theme } from '@factorialco/deprecated-design-system'
import { CalendarEvent, Widget } from '@factorialco/f0-react/dist/experimental'
import { MyTrainingsSessionFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

type Props = {
  session: MyTrainingsSessionFragment
}

export const NextSessionRow = ({ session }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  if (!session || session?.training?.status == 'draft') return null

  // Handle date conversion and formatting
  const startOn = session.startsAt ? stringToDate(session.startsAt, 'backend_datetime') : undefined
  const endOn = session.endsAt ? stringToDate(session.endsAt, 'backend_datetime') : undefined

  const getDescription = () => {
    if (!startOn) return ''
    if (!endOn) return startOn?.format('MMM D, YYYY') ?? ''

    if (startOn.isSame(endOn, 'day')) {
      // Same day: show time range
      return `${startOn.format('h:mm A')} - ${endOn.format('h:mm A')}`
    } else {
      // Different days: show date range
      return `${startOn.format('MMM D')} - ${endOn.format('MMM D, YYYY')}`
    }
  }

  const handleViewSession = () => {
    navigate(
      navigation.myTrainings.revamp.overview.sidepanel.fullPath({
        sessionId: session.id,
        trainingId: Number(session.training?.id),
      })
    )
  }

  return (
    <Widget
      header={{
        title: i18n.t('trainings.my_trainings_revamp.overview.next_session_title'),
      }}
    >
      <Box onClick={handleViewSession} style={{ minHeight: '50px' }}>
        <CalendarEvent
          title={session?.name ?? ''}
          description={getDescription()}
          color={theme.colors.viridian1200}
          isPending={false}
          {...(endOn && startOn && !endOn.isSame(startOn, 'day')
            ? { fromDate: startOn.toDate(), toDate: endOn.toDate() }
            : { toDate: startOn?.toDate() })}
        />
      </Box>
    </Widget>
  )
}
